import { Page } from "../../layout/Layout";
import { SectionPromo } from "../../shared/sections/SectionPromo";
import { LandingSections } from "./LandingSections";
import { useLandingSinglePageContext } from "@/helpers/contexts/LandingSinglePageContext";
import { orderLink } from "@/const";
import { BreadcrumbJsonLd } from "next-seo";
import crypto from "crypto";

const calculateLandingReviews = (url: string) => {
  const hash = crypto.createHash("sha256").update(url).digest("hex");

  const hashValue1 =
    parseInt(hash, 16) / parseInt("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", 16);

  const hashValue2 = parseInt(hash, 16);

  const ratingValue = Math.floor(47 + hashValue1 * (50 - 47 + 1)) / 10;
  const reviewCount = 500 + (hashValue2 % (2500 - 500 + 1));

  return {
    ratingValue,
    reviewCount,
  };
};

const LandingPage = () => {
  const data = useLandingSinglePageContext();

  if (!data) return null;

  const { landing, isPreview } = data;

  const { heading, subheading, meta, advantages, buttonText, sections, slug } = landing;

  return (
    <Page {...meta} isPreview={isPreview} metaReviews={calculateLandingReviews(landing.slug)}>
      <BreadcrumbJsonLd
        itemListElements={[
          { position: 1, name: "Main", item: "/" },
          {
            position: 2,
            name: heading,
            item: `/${slug}`,
          },
        ]}
      />
      <SectionPromo
        heading={heading}
        subheading={subheading}
        advantages={advantages}
        type="calculator"
        button={{
          text: buttonText || "Order now",
          props: {
            href: orderLink,
          },
        }}
        afterButtonText="Trusted by 437,286 satisfied students"
        reviews={{
          items: [
            {
              type: "studycrumb",
              rate: 4.7,
            },
            {
              type: "trustpilot",
              rate: 4.2,
            },
            {
              type: "reviews",
              rate: 4.6,
            },
            {
              type: "sitejabber",
              rate: 4.9,
            },
          ],
        }}
      />
      {sections && <LandingSections sections={sections} />}
    </Page>
  );
};

export default LandingPage;
